import * as API from '../api'
import { getApiErrorMessage } from '../utils'

// ============================================
// CONSTANTES - Tipos de ações
// ============================================
export const FETCH_CONTEUDO = 'FETCH_CONTEUDO'
export const FETCHING_CONTEUDO = 'FETCHING_CONTEUDO'
export const FETCH_CONTEUDO_ERROR = 'FETCH_CONTEUDO_ERROR'

export const FETCH_CONTEUDOS = 'FETCH_CONTEUDOS'
export const FETCHING_CONTEUDOS = 'FETCHING_CONTEUDOS'
export const FETCH_CONTEUDOS_ERROR = 'FETCH_CONTEUDOS_ERROR'

export const OPEN_CONTEUDO_MODAL = 'OPEN_CONTEUDO_MODAL'
export const CLOSE_CONTEUDO_MODAL = 'CLOSE_CONTEUDO_MODAL'

export const CHANGE_CONTEUDO = 'CHANGE_CONTEUDO'
export const NEW_FORM_CONTEUDO = 'NEW_FORM_CONTEUDO'
export const CONTEUDO_FORM_TOUCHED = 'CONTEUDO_FORM_TOUCHED'

export const ADD_CONTEUDO = 'ADD_CONTEUDO'
export const DELETE_CONTEUDO = 'DELETE_CONTEUDO'

export const CHANGE_CONTEUDO_PAGE = 'CHANGE_CONTEUDO_PAGE'
export const CHANGE_CONTEUDO_PER_PAGE = 'CHANGE_CONTEUDO_PER_PAGE'
export const CHANGE_CONTEUDO_TIPO_FILTER = 'CHANGE_CONTEUDO_TIPO_FILTER'

export const RESET_CONTEUDO_STATE = 'RESET_CONTEUDO_STATE'

// ============================================
// MODAL
// ============================================
export const openModal = () => (dispatch) => dispatch({ type: OPEN_CONTEUDO_MODAL })
export const closeModal = () => (dispatch) => dispatch({ type: CLOSE_CONTEUDO_MODAL })

// ============================================
// FORMULÁRIO
// ============================================
export const handleChangeConteudo = (conteudo) => (dispatch) =>
  dispatch({ type: CHANGE_CONTEUDO, conteudo })

export const newFormConteudo = () => (dispatch) => dispatch({ type: NEW_FORM_CONTEUDO })

export const setConteudoFormTouched = () => (dispatch) =>
  dispatch({ type: CONTEUDO_FORM_TOUCHED })

// ============================================
// PAGINAÇÃO
// ============================================
export const handleChangePage = (page) => (dispatch) =>
  dispatch({ type: CHANGE_CONTEUDO_PAGE, page })

export const handleChangePerPage = (perPage) => (dispatch) =>
  dispatch({ type: CHANGE_CONTEUDO_PER_PAGE, perPage })

export const changeTipoFilter = (tipo) => (dispatch) =>
  dispatch({ type: CHANGE_CONTEUDO_TIPO_FILTER, tipo })

// ============================================
// RESET
// ============================================
export const resetState = () => (dispatch) => dispatch({ type: RESET_CONTEUDO_STATE })

// ============================================
// API CALLS - LISTAR
// ============================================
export const fetchConteudos = (options) => (dispatch) => {
  dispatch({ type: FETCHING_CONTEUDOS })

  return API.contentVectorization
    .getConteudos(options)
    .then(({ data }) => {
      dispatch({
        type: FETCH_CONTEUDOS,
        conteudos: data.items,
        length: data.length,
        page: data.page,
        order: data.order,
        rowsPerPage: data.rowsPerPage,
      })
    })
    .catch((err) => {
      dispatch({ type: FETCH_CONTEUDOS_ERROR, err: getApiErrorMessage(err, 'Serviço indisponível') })
    })
}

// ============================================
// API CALLS - ADICIONAR
// ============================================
export const addConteudo = (conteudo) => (dispatch, getState) => {
  dispatch({ type: FETCHING_CONTEUDO })

  return API.contentVectorization
    .addConteudo(conteudo)
    .then(({ data }) => {
      const acceptedConteudo = {
        ...conteudo,
        ...data,
        content_id: data.content_id || conteudo.content_id || null,
        ciclo_uuid: data.ciclo_uuid || null,
        status: data.status || 'processing',
      }

      dispatch({
        type: ADD_CONTEUDO,
        conteudo: acceptedConteudo,
        contentId: acceptedConteudo.content_id,
        cicloUuid: acceptedConteudo.ciclo_uuid,
      })

      const state = getState().contentVectorization || {}
      const pagination = state.pagination || {}
      dispatch(
        fetchConteudos({
          page: pagination.page || 0,
          perPage: pagination.rowsPerPage || 20,
          tipo: state.tipoFilter || '',
        }),
      )

      return Promise.resolve(data)
    })
    .catch((err) => {
      dispatch({ type: FETCH_CONTEUDO_ERROR, err: getApiErrorMessage(err, 'Erro ao enviar conteúdo') })
      return Promise.reject(err)
    })
}

// ============================================
// API CALLS - DELETAR
// ============================================
export const deleteConteudo = (contentId) => (dispatch) => {
  dispatch({ type: FETCHING_CONTEUDOS })

  return API.contentVectorization
    .deleteConteudo(contentId)
    .then(() => {
      dispatch({ type: DELETE_CONTEUDO, contentId })
    })
    .catch((err) => {
      dispatch({ type: FETCH_CONTEUDOS_ERROR, err: getApiErrorMessage(err, 'Erro ao excluir conteúdo') })
      return Promise.reject(err)
    })
}

// ============================================
// API CALLS - REPROCESSAR
// ============================================
export const reprocessarConteudo = (contentId) => (dispatch) => {
  return API.contentVectorization
    .reprocessarConteudo(contentId)
    .then((response) => Promise.resolve(response.data))
    .catch((err) => Promise.reject(err))
}

// ============================================
// API CALLS - STATUS INDIVIDUAL
// ============================================
export const fetchConteudoStatus = (contentId) => (dispatch) => {
  return API.contentVectorization
    .getConteudoStatus(contentId)
    .then((response) => Promise.resolve(response.data))
    .catch((err) => Promise.reject(err))
}



// WEBPACK FOOTER //
// ./src/actions/contentVectorization.js